import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BrandEnum } from 'src/app/core/dtos/enum';

@Component({
  selector: 'app-sitting-type-selection',
  templateUrl: './sitting-type-selection.component.html',
  styleUrls: ['./sitting-type-selection.component.scss']
})
export class SittingTypeSelectionComponent implements OnInit {

  @Input() webDelivery: boolean;
  @Input() showPrivateSittings: boolean;
  @Input() brandId: BrandEnum;
  @Output() toggle: EventEmitter<boolean> = new EventEmitter<boolean>();

  caelFaqUrl = "https://www.cael.ca/faqs/";
  celpipFaqUrl = "https://www.celpip.ca/faqs/";
  faqUrl: string;
  testName: string;

  constructor() { }

  ngOnInit(): void {
    if (this.brandId === BrandEnum.CELPIP) {
      this.testName = "CELPIP";
      this.faqUrl = this.celpipFaqUrl;
    }
    else {
      this.testName = "CAEL";
      this.faqUrl = this.caelFaqUrl;
    }

  }

  public get BrandEnum() {
    return BrandEnum;
  }

  toggleTestType() {
    this.toggle.emit(this.showPrivateSittings);
  }

}
